var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTiktok = function SvgTiktok(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.043 8.269C15.8932 8.28483 15.7384 8.2901 15.5835 8.29538C13.9057 8.29538 12.3415 7.43015 11.4226 5.99515V13.8191C11.4226 17.0162 8.88791 19.6013 5.76468 19.6013C2.64145 19.6013 0.101562 17.0162 0.101562 13.8191C0.101562 10.622 2.63629 8.03687 5.75952 8.03687C5.87825 8.03687 5.99182 8.04742 6.11056 8.05269V10.9016C5.99699 10.8858 5.87825 10.8647 5.75952 10.8647C4.16435 10.8647 2.86859 12.1889 2.86859 13.8191C2.86859 15.4493 4.16435 16.7735 5.75952 16.7735C7.35469 16.7735 8.76402 15.4862 8.76402 13.856L8.78983 0.566406H11.4588C11.7117 3.01435 13.6373 4.92417 16.0378 5.10355V8.269",
    fill: "#1A1A1A"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTiktok);
export default ForwardRef;